"use client";

import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useState, useEffect } from "react";
import { Recorder } from "./recorder";
import { SummaryDisplay } from "./summary-display";
import { DeleteConfirmationModal } from "./delete-confirmation-modal";
import { useRouter } from "next/router";
import useGetMeetingsList from "../hooks/useGetMeetingsList";
import useGetMeeting from "../hooks/useGetMeeting";
import { isEmpty } from "lodash";
import classNames from "classnames";
export var summaryTypes = {
  detailed: "Detailed summary",
  highlights: "Only highlights"
};
export function Synapse(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? "system" : _ref$theme;
  var _useState = useState(null),
    selectedMeeting = _useState[0],
    setSelectedMeeting = _useState[1];
  var _useState2 = useState("detailed"),
    typeOfSummary = _useState2[0],
    setTypeOfSummary = _useState2[1];
  var _useState3 = useState(false),
    isRecording = _useState3[0],
    setIsRecording = _useState3[1];
  var _useState4 = useState({
      show: false,
      id: null,
      title: ""
    }),
    deleteConfirmation = _useState4[0],
    setDeleteConfirmation = _useState4[1];
  var router = useRouter();

  // API hooks
  var _useGetMeetingsList = useGetMeetingsList(),
    _useGetMeetingsList$d = _useGetMeetingsList.data,
    meetings = _useGetMeetingsList$d === void 0 ? [] : _useGetMeetingsList$d,
    isLoadingHistory = _useGetMeetingsList.isLoading,
    historyError = _useGetMeetingsList.error,
    refetchMeetings = _useGetMeetingsList.refetch;
  var _useGetMeeting = useGetMeeting(selectedMeeting === null || selectedMeeting === void 0 ? void 0 : selectedMeeting.id),
    currentMeetingData = _useGetMeeting.data,
    isMeetingLoading = _useGetMeeting.isLoading,
    refetchCurrentMeeting = _useGetMeeting.refetch;
  useEffect(function () {
    if (currentMeetingData && (selectedMeeting === null || selectedMeeting === void 0 ? void 0 : selectedMeeting.id) === currentMeetingData.id) {
      var _meeting = _objectSpread(_objectSpread({}, selectedMeeting), {}, {
        details: currentMeetingData.details,
        updated_at: currentMeetingData.updated_at,
        audio_file_url: currentMeetingData.audio_file_url
      });
      setSelectedMeeting(_meeting);
    }
  }, [currentMeetingData]);

  // Set theme class on body
  useEffect(function () {
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else if (theme === "light") {
      document.documentElement.classList.remove("dark");
    } else {
      // System theme
      if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
    }
  }, [theme]);
  var isMeetingSelected = selectedMeeting && !isEmpty(selectedMeeting.details);
  return /*#__PURE__*/React.createElement("div", {
    className: "meeting-summarizer min-h-screen bg-gray-50 dark:bg-gray-950 text-gray-900 dark:text-gray-100 h-full flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col min-h-screen h-full"
  }, /*#__PURE__*/React.createElement("header", {
    className: "border-b border-gray-200 dark:border-gray-800 p-4 sticky top-0 z-30 bg-white/80 dark:bg-gray-950/80 backdrop-blur-sm"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container mx-auto flex justify-between items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-7 h-7 mr-5 relative shadow-lg cursor-pointer focus:outline-none focus:ring-2 focus:ring-teal-400 hover:opacity-100",
    tabIndex: 0,
    role: "button",
    "aria-label": "Go to patients page",
    onClick: function onClick() {
      return router.replace("/synapse");
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter" || e.key === " ") {
        router.replace("/synapse");
      }
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "/assets/icons/qure_q_logo.png",
    alt: "Qure Logo",
    width: 28,
    height: 28,
    className: "w-full h-full object-cover opacity-90"
  })), /*#__PURE__*/React.createElement("h1", {
    className: "text-3xl font-bold text-gray-900 dark:text-white"
  }, "Synapse")))), /*#__PURE__*/React.createElement("main", {
    className: "flex flex-col h-full container mx-auto px-4 py-6 space-y-4 overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("flex flex-col h-full", {
      hidden: !isMeetingSelected
    })
  }, /*#__PURE__*/React.createElement(SummaryDisplay, {
    selectedMeeting: selectedMeeting,
    setSelectedMeeting: setSelectedMeeting,
    onUpdateMeeting: function onUpdateMeeting() {
      refetchCurrentMeeting();
      refetchMeetings();
    },
    typeOfSummary: typeOfSummary,
    setTypeOfSummary: setTypeOfSummary,
    refetchMeetings: refetchMeetings
  })), /*#__PURE__*/React.createElement("div", {
    className: classNames("flex flex-col h-full", {
      hidden: isMeetingSelected
    })
  }, /*#__PURE__*/React.createElement(Recorder, {
    meetings: meetings || [],
    refetchMeetings: refetchMeetings,
    isLoadingHistory: isLoadingHistory,
    historyError: historyError,
    setSelectedMeeting: setSelectedMeeting,
    typeOfSummary: typeOfSummary,
    setTypeOfSummary: setTypeOfSummary,
    isRecording: isRecording,
    setIsRecording: setIsRecording
  }))))), /*#__PURE__*/React.createElement(DeleteConfirmationModal, {
    isOpen: deleteConfirmation.show,
    onClose: function onClose() {
      return setDeleteConfirmation({
        show: false,
        id: null,
        title: ""
      });
    },
    onConfirm: function onConfirm() {
      // Note: Delete logic is now handled in the Recorder component via API
      // This modal is kept for potential future use
      setDeleteConfirmation({
        show: false,
        id: null,
        title: ""
      });
    },
    title: deleteConfirmation.title
  }));
}